import { Galerie } from '@components/galerie/models';
import { galerieTextMock, imageMock, videoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const galerieit2iviMock: Block<Galerie> = {
  type: 'galerie',
  data: {
    layout: 'it2ivi',
    title: {
      text: `La tendance [[Moccha Mousse]]`,
      as: 'h2',
    },
    hideLastItem: false,
    items: [
      {
        image: imageMock,
      },
      {
        text: galerieTextMock,
      },
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
      {
        video: videoMock(),
      },
      {
        image: imageMock,
      },
    ],
    cta: {
      label: `Nos cuisines moccha mousse`,
      url: '/mock-cuisines/moccha-mousse',
    },
  },
};
